import { all } from "redux-saga/effects";
import sagaUtils from "../sagaUtils";
import dataRequestFunctions from "./dataRequestFunctions";

export default function* rootSaga() {
  yield all(sagaUtils.extractRequestFunctions(dataRequestFunctions));
}
